import type {
  ToggleGroupItemProps,
  ToggleGroupSingleProps,
} from '@radix-ui/react-toggle-group';

import {
  CardToggleGroupItem,
  CardToggleGroupItemDescription,
  CardToggleGroupItemHeader,
} from './CardToggleGroup';
import {
  RadioToggleGroupIcon,
  RadioToggleGroupItem,
  RadioToggleGroupRoot,
} from './RadioToggleGroup';

export const RadioToggleGroup = {
  Root: RadioToggleGroupRoot,
  Item: RadioToggleGroupItem,
  Icon: RadioToggleGroupIcon,
};

export const CardToggleGroup = {
  Root: RadioToggleGroupRoot,
  Item: CardToggleGroupItem,
  ItemHeader: CardToggleGroupItemHeader,
  ItemDescription: CardToggleGroupItemDescription,
};

export type { ToggleGroupItemProps, ToggleGroupSingleProps };
